import { initFirebase } from '../firebase'
import { collection, addDoc, updateDoc, doc, getDoc, getDocs, query, orderBy, serverTimestamp, arrayUnion } from 'firebase/firestore'

const { db } = initFirebase()

export class PromptTestService {
  async createTestSession(userId, userName, testNumber = 1) {
    const ref = await addDoc(collection(db, 'promptTests'), {
      userId,
      userName,
      testNumber,
      createdAt: serverTimestamp(),
      completedAt: null,
      context: null,
      questionResults: [],
      wrapUp: null
    })
    return ref.id
  }

  async saveContext(testId, contextData) {
    await updateDoc(doc(db, 'promptTests', testId), { context: contextData })
  }

  async saveQuestionResult(testId, result) {
    await updateDoc(doc(db, 'promptTests', testId), {
      questionResults: arrayUnion(result)
    })
  }

  async saveWrapUp(testId, wrapUpData) {
    await updateDoc(doc(db, 'promptTests', testId), {
      wrapUp: wrapUpData,
      completedAt: serverTimestamp()
    })
  }

  async getAllTests() {
    const ref = collection(db, 'promptTests')
    const q = query(ref, orderBy('createdAt', 'desc'))
    const snap = await getDocs(q)
    return snap.docs.map(d => ({ id: d.id, ...d.data() }))
  }

  async getTestById(testId) {
    const snap = await getDoc(doc(db, 'promptTests', testId))
    if (snap.exists()) return { id: snap.id, ...snap.data() }
    return null
  }
}
